import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

export const stimulus = () => {
  const application = Application.start();
  application.debug = false;
  window.Stimulus = application;
  // import dir: blog
  const controllers = import.meta.glob("./blog/**/*_controller.js", { eager: true });
  registerControllers(application, controllers);
};
